import { t } from "i18next";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { useAppStore } from "../../../stores/RootStore";
import { ScreenType } from "../../../types/types";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/Input/Input";
import { Label } from "../../../ui/Label/Label";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { Switch } from "../../../ui/Switch/Switch";
import { customAlphabet, nanoid } from "nanoid";

const AddScreen = () => {
  const {screens, setScreens} = useAppStore()
  const navigate = useNavigate()
  const [errors, setErrors] = useState([]);
  const { register, reset, handleSubmit, control } = useForm({
    defaultValues: {
      name: "",
      slug: "",
      public: true,
    },
  });

  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] =
    useFetch(`/directories/screens`);

  const onSubmit = (formData: any) => {
    let generator = customAlphabet('0123456789abcdefghijklmnopqrstuvwxyz', 10)
    setErrors([]);
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          name: formData.name,
          slug: generator(),
          public: formData.public,
        },
      },
    });
    reset();
  };

  const slugify = (...args: (string | number)[]): string => {
    const value = args.join(' ')

    return value
      .normalize('NFD') // split an accented letter in the base letter and the acent
      .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
      .replace(/\s+/g, '-') // separator
}

  const addScreen = (itemSaveResponse: { data: unknown }) => {
    const newScreenData = itemSaveResponse.data as unknown as ScreenType;
    setScreens([...(screens ? screens : []), newScreenData]);
    navigate(`/monitoring/${newScreenData.id}`)
  };

  useEffect(() => {
    if (!saveResponse) return;
    addScreen(saveResponse);
  }, [saveResponse]);

  useEffect(() => {
    if (!saveError) return;
    setErrors(saveError.errors);
  }, [saveError]);

  return (
    <ScrollArea className="w-full">
      <div className="flex flex-col max-w-[900px] w-full justify-start mx-auto pl-4 pr-16 relative overflow-hidden my-[4rem]">
        <div className="text-xl font-semibold">{t("adding_screen")}</div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col w-full pt-8 h-full gap-3">
            <Controller
              name="name"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("screen_name")}*`} />
                </div>
              )}
            />
            {/* <Controller
              name="slug"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <Input {...field} label={`${t("screen_slug")}*`} />
                </div>
              )}
            /> */}
            <Controller
              name="public"
              control={control}
              render={({ field }) => (
                <div className="relative space-y-2">
                  <div className="flex items-center space-x-2">
                    <Switch checked={field.value} onCheckedChange={field.onChange} id="public" />
                    <Label htmlFor="public">{t("screen_public")}</Label>
                  </div>
                </div>
              )}
            />

            <Button type="submit" className="mt-8">
              {t("save")}
            </Button>
          </div>
        </form>
      </div>
    </ScrollArea>
  );
};

export default AddScreen;
